import SpreadGuidance from '../../../.././../../models/data/SpreadGuidance';
import * as React from 'react';
import ValueEditor from './ValueEditor';
import RangeEditor from './RangeEditor';
import VariationEditor from './VariationEditor';
import GenericBenchmarkPicker from '../pricing/GenericBenchmarkPicker';
import PopupContext from 'contexts/PopupContext';
import SpreadRangeValueSwitch from './RangeValueSwitchExtended';
const SpreadGuidanceEditor = ({ value, onChange }) => {
    const { setBlockClose } = React.useContext(PopupContext);
    const [rangeValue, setRangeValue] = React.useState(() => {
        if (value?.floatingEquivalent) {
            return 'float';
        }
        return value?.range !== undefined ? 'range' : 'value';
    });
    const [typePicker, setTypePicker] = React.useState(value?.benchmark === undefined);
    const onChangeRange = React.useCallback((event) => {
        const updated = value !== undefined ? value.updateRange(event.target.value) : new SpreadGuidance({ range: event.target.value });
        onChange({ target: { value: updated } });
    }, [onChange, value]);
    const onChangeValue = React.useCallback((event) => {
        const updated = value !== undefined ? value.updateValue(event.target.value) : new SpreadGuidance({ value: event.target.value });
        onChange({ target: { value: updated } });
    }, [onChange, value]);
    const onChangeVariation = React.useCallback((event) => {
        const updated = value !== undefined ? value.updateVariation(event.target.value) : new SpreadGuidance({ variation: event.target.value });
        onChange({ target: { value: updated } });
    }, [onChange, value]);
    const content = React.useMemo(() => {
        switch (rangeValue) {
            case 'range':
                return React.createElement(RangeEditor, { value: value?.range, onChange: onChangeRange });
            case 'value':
                return React.createElement(ValueEditor, { value: value?.value, onChange: onChangeValue });
            default:
                return undefined;
        }
    }, [onChangeRange, onChangeValue, rangeValue, value?.range, value?.value]);
    const saveBenchmark = React.useCallback((benchmark) => {
        const newSpread = value !== undefined ? value.updateBenchmark(benchmark) : new SpreadGuidance({ benchmark });
        onChange({ target: { value: newSpread } });
        setTypePicker(false);
    }, [onChange, value]);
    const onClick = React.useCallback(() => {
        setBlockClose(true);
        setTypePicker(true);
    }, [setBlockClose]);
    const changeRangeValue = React.useCallback((newRangeValue) => {
        setRangeValue(newRangeValue);
        const updated = value !== undefined ? value.updateFloatingEquivalent(newRangeValue === 'float') : new SpreadGuidance({ floatingEquivalent: true });
        onChange({ target: { value: updated } });
    }, [onChange, value]);
    return React.createElement("div", null, typePicker ? React.createElement(GenericBenchmarkPicker, { initial: value?.benchmark, setInitialBenchmark: saveBenchmark })
        :
            React.createElement(React.Fragment, null,
                React.createElement(SpreadRangeValueSwitch, { rangeValue: rangeValue, setRangeValue: changeRangeValue }),
                React.createElement("div", { style: { display: 'flex' } },
                    React.createElement("span", { onClick: onClick, style: { alignSelf: 'end', marginBottom: '0.5rem', marginRight: '0.5rem' } }, (value?.benchmark?.print() ?? "?") + " +"),
                    value?.benchmark !== undefined ?
                        !value.floatingEquivalent ?
                            React.createElement(React.Fragment, null,
                                content,
                                React.createElement(VariationEditor, { value: value.variation, onChange: onChangeVariation }))
                            : 'Equivalent'
                        : undefined)));
};
export default SpreadGuidanceEditor;
